import { render, staticRenderFns } from "./SaleGoodsItem.vue?vue&type=template&id=4725b294&scoped=true"
import script from "./SaleGoodsItem.vue?vue&type=script&lang=js"
export * from "./SaleGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./SaleGoodsItem.vue?vue&type=style&index=0&id=4725b294&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4725b294",
  null
  
)

export default component.exports